<template>
  <div id="contact-modal" style="max-width:400px;margin:auto">
    <v-layout row justify-center>
      <v-card>
        <v-card-media src="/static/images/shared/boot-1992136_640.jpg">
        </v-card-media>

        <v-card-title>
          <div class="headline">Kontakt</div>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-icon>email</v-icon>
              <span>info@smolin-budgetplan.com</span>
            </v-flex>

          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-icon>call</v-icon>
              <span>+49(0)30 756 523 31</span>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue-grey darken-2" block dark @click.stop="dialog=true">Anfrage stellen &raquo;</v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Anfrage stellen:</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field label="Firma" v-model="postBody.company"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Name" v-model="postBody.name" required hint="Ihr Name"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Email" v-model="postBody.email" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Telefon" v-model="postBody.phone"></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field label="Ihre Anfrage" v-model="postBody.message" required textarea :rules="[(v)=> v.length <=280 || 'Max. 280 Zeichen']" :counter="100">

                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <small>*diese Angaben sind erforderlich</small>
            <p><router-link to="privacy">Datenschutzerklärung</router-link></p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="dialog = false">Schliessen</v-btn>
            <v-btn color="blue darken-1" flat @click.native="sendMessage()">Absenden</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'

  export default {
    name: 'ContactWidget',
    data () {
      return {
        dialog: false,
        postBody : {
          company: '',
          name: '',
          email: '',
          phone: '',
          message: ''
        }
      }
    },
    methods : {
      sendMessage() {
        this.dialog =false;

        axios.post('https://api.smolin-budgetplan.com/api/message/contact', this.postBody)
          .then(response => {
          // JSON responses are automatically parsed.
          //this.posts = response.data
          console.log("axios response",response);
        })
        .catch(e => {
          console.log("axios error:",e)
          //this.errors.push(e)
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/widgets/ContactWidget.vue